import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PlateService from 'business/services/PlateService';
import { InspectionSetGroupDTO } from 'business/models/Models';
import { LoadingModal } from 'components/modal';
import { RMRadioButton } from 'components/customComponents/Layers/InputGroups';
import { IStyle } from 'Styles';
import { useSelectedDropImageParameters } from 'redux/hooks/experiment';

type ExportScoresOptionProps = {
  docData: ExperimentDtoClient;
  canvasRef: any;
  platePadding: number;
};

export type ImageReportOptionsDTO = {
  dropNumber: string;
  inspection: number;
  fitToPage: boolean;
  rowLimit: number;
  columnLimit: number;
};

export function OptionsRadioButton({ onClick, value, label, selected }: any) {
  return (
    <RMRadioButton
      selected={selected}
      value={value}
      styleLabel={Styles.radioButtonLable}
      styleCircle={Styles.radioButtonCircle}
      style={Styles.radioButtonStyle}
      onClick={(e) => onClick(e)}
      label={label}
    />
  );
}

export const ExportScoresOptions = forwardRef((props: ExportScoresOptionProps, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectInspection, setSelectInspection] = useState('currentInspection');
  const selectedDropImageParameters = useSelectedDropImageParameters();
  useImperativeHandle(ref, () => ({
    generateAction,
  }));

  async function generateAction() {
    setIsLoading(true);
    const plateService = new PlateService();
    let inspectionSetGroupData = [];

    if (selectInspection === 'currentInspection') {
      selectedDropImageParameters?.inspection?.groupedInspections.forEach((gpIns) => {
        const inspectionSetGroup: InspectionSetGroupDTO = gpIns;
        inspectionSetGroupData.push(inspectionSetGroup);
      });
    } else if (selectInspection === 'latestInspection') {
      const totalLenght = props.docData.inspections.length;
      const latestInspection = props.docData.inspections[totalLenght - 1];
      latestInspection.groupedInspections.forEach((gpIns) => {
        const inspectionSetGroup: InspectionSetGroupDTO = gpIns;
        inspectionSetGroupData.push(inspectionSetGroup);
      });
    } else if (selectInspection === 'allInspections') {
      props.docData.inspections.forEach((insp) => {
        insp.groupedInspections.forEach((gpIns) => {
          const inspectionSetGroup: InspectionSetGroupDTO = gpIns;
          inspectionSetGroupData.push(inspectionSetGroup);
        });
      });
    }

    const fileResponse = await plateService.generateInspectionCSVFile(
      inspectionSetGroupData,
      props.docData.experimentId,
      props.docData.expName,
    );
    const blob = new Blob([fileResponse.data]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileResponse.fileName;
    link.click();

    inspectionSetGroupData = [];
    setIsLoading(false);
  }

  const handleInspectionSelectedValue = (e) => {
    setSelectInspection(e.target.value);
  };

  return (
    <div
      id='exportscoresoptions-wrapper'
      className="dashed-border d-flex h-100 p-2 flex-column"
      style={{ height: '40rem' }}
    >
      <div id='exportscoresoptions-message' className="text-p mb-2">
        Please provide information you want to include into the file.
      </div>
      <div id="exportscoresoptions-content" className="d-flex flex-row h-90">
        <div id="exportscoresoptions-left-panel" className="flex-50 p-2 d-flex flex-column">
          <div id="exportscoresoptions-label-row" className="row">
            <div id="exportscoresoptions-text-export-scores" className="text-p col-md-6" style={{ marginLeft: '10px' }}>
              <label id="exportscoresoptions-label-export-scores">Export scores from:</label>
            </div>
          </div>
          <div id="exportscoresoptions-radio-row" className="row">
            <div id="exportscoresoptions-radio-group" className="col-md-6" style={{ marginLeft: '10px' }}>
              <OptionsRadioButton
                id="exportscoresoptions-radio-current"
                onClick={handleInspectionSelectedValue}
                value="currentInspection"
                label="Current Inspection"
                selected={selectInspection}
              />
              <OptionsRadioButton
                id="exportscoresoptions-radio-latest"
                onClick={handleInspectionSelectedValue}
                value="latestInspection"
                label="Latest Inspection"
                selected={selectInspection}
              />
              <OptionsRadioButton
                id="exportscoresoptions-radio-all"
                onClick={handleInspectionSelectedValue}
                value="allInspections"
                label="All Inspection"
                selected={selectInspection}
              />
            </div>
          </div>
        </div>
      </div>
      <LoadingModal showModal={isLoading} text={'Preparing'} />
    </div>
  );
});

const Styles: IStyle = {
  radioButtonLable: {
    fontFamily: 'Arial',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '23px',
    letterSpacing: '0em',
    textAlign: 'left',
  },
  radioButtonCircle: {
    height: '1.25rem',
    width: '1.25rem',
    marginRight: '0.75rem',
    display: 'block',
  },
  radioButtonStyle: {
    display: 'flex',
    alignItems: 'center',
  },
};
